const CART_ADD_ITEMS_PREFIX = "caipx";

export const CART_ADD_ITEMS_TEST_IDS = {
    TEXT: `${CART_ADD_ITEMS_PREFIX}_text`,
    BUTTON: `${CART_ADD_ITEMS_PREFIX}_button`,
};
